import React, {useEffect, useState} from "react";
import ApiCheck from '../../Structure/ApiCheck.tsx';
import { useCertificatesApi } from "../../../features/auth/hooks/use-certifictates-api.ts";
import { ICertificate } from "../../../interface/ICertificate.ts";
import '../../../scss/components/Certificates.scss';
import { useClientAccountApi } from "../../../features/auth/hooks/use-client-account-api.ts";
import { IClientAccount } from "../../../interface/IClientAccount.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import SingleCertificateItemRepeater from "../../ClientAccounts/SingleCertificateItemRepeater.tsx";

const TabCertificates = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [hasCertificates, setHasCertificates] = useState<boolean>(false);
    const { getCertificates } = useCertificatesApi();
    const { getClientAccounts } = useClientAccountApi();
    const { getList } = useListsApi();

    const [apiErrors, setApiErrors] = useState<any>();

    const [clientCertificates, setClientCertificates] = useState<Object>({
        'CFP': {},
        'EFA': {},
        'CFEP': {},
        'CGA': {},
        'HonCFP': {},
        'HonCFEP': {},
        'FPSB Emeritus': {},
    });
    const [dinIsoCertificate, setDinIsoCertificate] = useState<ICertificate|null>(null);
    const [clientAccounts, setClientAccounts] = useState<Array<ICertificate>|any>([]);
    const [toggledStates, setToggledStates] = useState<Array<Number>|any>([]);

    const [certificateTypes, setCertificateTypes] = useState<Array<string>>([]);
    const [hasEmeritus, setHasEmeritus] = useState<boolean>(false);

    const handleApiError = () => {
        setApiErrors({
            errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
        });
        setIsLoading(false);
    }

    useEffect(() => {
        getList('client_account_type').then(res => {
            let optionListLabels:Array<string> = [];
            if (res) {
                let accountTypeLabels:Object = {};
                //Collect private and Company Account Type to easier handle conditional display of fields
                res.forEach((item:any) => {
                    if (item.type === 'private') {
                        accountTypeLabels[item.id] = item.label;
                    }
                    if (item.type === 'company') {
                        accountTypeLabels[item.id] = item.label;
                    }
                    optionListLabels.push(item.label);
                });

                //Fetch the Certificates of the user now that we have all Accounts
                getClientAccounts().then(data => {
                    let accountsArray = data.payload;
        
                    let accountNamesByID = {};
                    if (accountsArray && typeof accountsArray == 'object') {
                        accountsArray.forEach((account:IClientAccount) => {
                            if (account.id) {
                                accountNamesByID[account.id] = account.name;
                            }
                        });
                        //Move accounts into state
                        setClientAccounts(accountNamesByID);
                    }
        
                }).catch(handleApiError);
        
                getCertificates().then(data => {
                    let certificatesArray = data.payload;
        
                    if (certificatesArray && typeof certificatesArray == 'object' && !isEmpty(certificatesArray)) {
                        //Move certs into state
                        let types:Array<string> = [];
                        let certificatesByType = {
                            'CFP': {},
                            'EFA': {},
                            'CFEP': {},
                            'CGA': {},
                            'HonCFP': {},
                            'HonCFEP': {},
                            'FPSB Emeritus': {},
                        }
                        let checkHasEmeritus = false;
                        certificatesArray.forEach((certificate:ICertificate) => {
                            if (certificate.type.replaceAll(' ', '').toLowerCase() === 'fpsbemeritus') {
                                setHasEmeritus(true);
                                checkHasEmeritus = true;
                            }
                            if (certificate.type === 'DIN-ISO 22222') {
                                setDinIsoCertificate(certificate);
                            } else {
                                types.push(certificate.type);
                                if (Object.keys(certificatesByType).includes(certificate.type)) {
                                    //@ts-ignore
                                    certificatesByType[certificate.type] = certificate;
                                }
                            }
                        });
                        if (checkHasEmeritus) { //Remove other certs as emeritus always takes precedence
                            certificatesByType.CFP = {};
                            certificatesByType.EFA = {};
                            certificatesByType.CFEP = {};
                            certificatesByType.CGA = {};
                            certificatesByType.HonCFP = {};
                            certificatesByType.HonCFEP = {};
                            setDinIsoCertificate(null);
                        }

                        setClientCertificates(certificatesByType);
                        setCertificateTypes(types);
                        setHasCertificates(true);
        
                        //Create Toggle State of Tabs
                        setToggledStates(new Array(certificatesArray.length).fill(false));
                    }
        
                    setIsLoading(false);
                }).catch(handleApiError);
            }
        })



        
    }, []);

    //Visually open/close a single ClientAccountForm
    const toggleAccount = (key:number) => {
        let toggledStatesClone = Array(toggledStates.length).fill(false);
        if (!toggledStates[key]) {
            toggledStatesClone[key] = true;
            let repeaterHeadline = document.querySelector('.form-group.certifcate-item:nth-child('+(key+1)+')');
            if (repeaterHeadline) {
                setTimeout(() => {
                    var headerOffset = 25;
                    var elementPosition = repeaterHeadline.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                         top: offsetPosition,
                         behavior: "smooth"
                    });
                }, 0);
            }
        }
        setToggledStates(toggledStatesClone);
    }

    const isEmpty = (obj:any) => {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }

        return true;
    }

    let loopIndex:number = -1;

    return (
        <div className="single-tab-item">
            { isLoading ? (
                <div className="loader"></div>
            ) : (
                <ApiCheck errors={apiErrors ? apiErrors : null}>                    
                    <div className="certificates-list repeater">
                        { hasCertificates ? (
                            <>
                                { Object.values(clientCertificates).map((certificate:ICertificate, key:number) => {
                                    if (!isEmpty(certificate)) {
                                        loopIndex++;
                                        return (
                                            <SingleCertificateItemRepeater 
                                                toggleAccount={toggleAccount}
                                                key={key}
                                                index={loopIndex}
                                                toggledStates={toggledStates}
                                                certificateTypes={certificateTypes}
                                                certificate={certificate}
                                                clientCertificates={clientCertificates}
                                                clientAccounts={clientAccounts}
                                            />
                                        )                                    
                                    } else {
                                        return '';
                                    }
                                }) }
                                { !hasEmeritus && dinIsoCertificate !== null ? (
                                    <SingleCertificateItemRepeater 
                                        toggleAccount={toggleAccount}
                                        index={loopIndex + 1}
                                        toggledStates={toggledStates}
                                        certificateTypes={['DIN-ISO 22222']}
                                        certificate={dinIsoCertificate}
                                        clientCertificates={clientCertificates}
                                        clientAccounts={clientAccounts}
                                    />
                                ) : ''}
                            </>
                        ) : (
                            <p>Für Sie sind noch keine Zertifikate vorhanden</p>
                        ) }
                    </div>
                </ApiCheck>
            ) }
        </div>
    )
}

export default TabCertificates;